import { useAtomValue } from 'jotai'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import CollectionCalendar from '@/components/collection-calendar/calendar'
import CollectionTables from '@/components/collection-calendar/tables'
import CollectionCalendarInfo from '@/components/collection-calendar/info'
import { selectedMunicipalityIdAtom } from '@/state'

function CollectionCalendarView() {

    const title = 'Svozový kalendář'

    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper>
                <Typography variant="h2" component="h1" mb={3}>
                    {title}
                </Typography>
                {municipalityId ?
                    <>
                        <CollectionTables />
                        <Box pt={5} />
                        <CollectionCalendar />
                        <Box pt={5} />
                        <Box position="relative">
                            <Typography variant="h3" component="h5" gutterBottom>Další informace a soubory ke stažení</Typography>
                            <CollectionCalendarInfo />
                        </Box>
                    </>
                    :
                    <Box>
                        Vyberte prosím konkrétní obec výše.
                    </Box>
                }
            </CustomPaper>
        </>
    )
}

export default CollectionCalendarView
